import React, { useState, useEffect } from 'react'
import { Grid, Tab } from '@material-ui/core'
import { TabContext, TabList, TabPanel, Pagination } from '@material-ui/lab'
import { useDispatch, useSelector } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { useMediaItems } from './hooks/useMediaItems'
import { useAiState } from './hooks/useAiState'
import { useFileHandling } from './hooks/useFileHandling'
import { MediaUploader } from './media-uploader'
import { SearchBar } from './search-bar'
import MediaGrid from './media-grid'
import Giphy from './giphy'
import Unsplash from './unsplash'
import EmbedImage from './embed-image'
import AiImage from './ai-image-generation'
import { mediaDirectoryGetRoot } from 'src/reducers/media-directory/action'
import { mediaImageUploadAction } from 'src/reducers/media-image/action'
import style from './style'

const ImageGallery = ({
  classes,
  cardEntity,
  popupType,
  onOk,
  setImageURL,
  assignment,
  type,
}) => {
  const dispatch = useDispatch()
  const entity = useSelector(state => state.mediaDirectory.entity)

  const [page, setPage] = useState(1)
  const [filterText, setFilterText] = useState(null)
  const [tabValue, setTabValue] = useState(type ? 6 : 1)
  const [folderId, setFolderId] = useState(null)

  const { items, handleSelect, addItem } = useMediaItems(setImageURL)
  const { aiState, setAiCount, handleLoading, fetchLimits } = useAiState()
  const { getMediaItemType } = useFileHandling()

  useEffect(() => {
    if (items.length > 0) {
      onOk(items)
    }
  }, [items, onOk])

  useEffect(() => {
    fetchLimits()
  }, [fetchLimits])

  useEffect(() => {
    dispatch(mediaDirectoryGetRoot(page, filterText))
  }, [dispatch, page, filterText])

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const handleFileUpload = file => {
    const mediaType = getMediaItemType(file.type)
    if (!mediaType) return

    dispatch(mediaImageUploadAction(file, folderId, data => addItem(data.url)))
  }

  return (
    <Grid container className={classes.root}>
      <TabContext value={tabValue}>
        <Grid container className={classes.headerContent} alignContent="center">
          <TabList
            onChange={handleTabChange}
            TabIndicatorProps={{ style: { background: '#00AB55' } }}
            textColor="#00AB55"
          >
            <Tab disableRipple label="Create with AI" value={6} />
            <Tab disableRipple label="My Media" value={1} />
            <Tab disableRipple label="Add by Link" value={5} />
            <Tab disableRipple label="Giphy" value={3} />
            <Tab disableRipple label="Unsplash" value={4} />
          </TabList>
        </Grid>

        <TabPanel value={tabValue} index={1} hidden={tabValue !== 1}>
          <Grid container className={classes.content}>
            <Grid item width="100%">
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <SearchBar value={filterText} onChange={setFilterText} />
                </Grid>
                <Grid item>
                  <MediaUploader
                    onUpload={handleFileUpload}
                    classes={classes}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item style={{ maxHeight: '418px' }}>
              <MediaGrid
                items={entity?.results}
                onSelect={handleSelect}
                dispatch={dispatch}
                classes={classes}
              />
            </Grid>

            {entity?.totalPages > 0 && (
              <Grid item>
                <Pagination
                  count={entity.totalPages}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                />
              </Grid>
            )}
          </Grid>
        </TabPanel>

        <TabPanel value={tabValue} index={6} hidden={tabValue !== 6}>
          <AiImage
            cardEntity={cardEntity}
            assignment={assignment}
            onPhotoClick={addItem}
            setAiCount={setAiCount}
            dispatch={dispatch}
            count={aiState.count}
            limit={aiState.limit}
            loading={aiState.loading}
            handleLoading={handleLoading}
            refreshedAt={aiState.refreshedAt}
            popupType={popupType}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={3} hidden={tabValue !== 3}>
          <Giphy
            onGifClick={gif => addItem(gif.images.original.url)}
            classes={classes}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={4} hidden={tabValue !== 4}>
          <Unsplash onPhotoClick={addItem} />
        </TabPanel>

        <TabPanel value={tabValue} index={5} hidden={tabValue !== 5}>
          <EmbedImage onPhotoClick={addItem} />
        </TabPanel>
      </TabContext>
    </Grid>
  )
}

export default withStyles(style, { withTheme: true })(ImageGallery)
